<template>
    <div class="brand-page">
        <div class="row no-gutters brands-hero2" id="Hearos2">
            <div>
                <img src="/images/brand-bgs/brand-logo-bg.png" alt="background">
                <img src="/images/brand-logos/hearos-trimmed.png" alt="hearos logo">
            </div>
        </div>

        <div class="brand-content">
            <div>
                <p>
                    Not all hearing protection is created equal - SO THAT'S WHERE WE COME IN!  
                    For over 30 years, we at Hearos® have been developing multi-faceted ear protection solutions for people of all ages on a DIY and professional level. 
                    We understand the engineering and specific designs that are necessary to meet your noise reduction needs. 
                    Sometimes, you want to completely tune out dangerously loud sounds like lawnmowers.  Other times, you're looking for a comfortable nights' sleep by blocking out your partners snoring or buzzing city traffic. 
                    All our plugs have been NRR tested and rated (trust us, that's important!) and are categorized by the necessary level of protection needed for any task you'll take on.  
                    With our strong North American manufacturing and unique proprietary foam technology, PowerSoft™, Hearos® delivers optimal protection at maximum comfort, every time!  
                </p>
                <a href="https://www.hearos.com/" class="btn-round-black" target="_blank">Hearos.com</a>
            </div>
        </div>

        <div class="socialspace" style="background-color: rgb(44, 151, 216);">
            <div>
                <div>
                    <h4>Follow Us</h4>
                    <div>
                        <a href="https://www.facebook.com/HEAROSEARPLUG/" target="_blank">
                            <font-awesome-icon class="social-icon" :icon="['fab', 'square-facebook']"  />
                        </a>
                        <a href="https://www.youtube.com/channel/UCcOxDwEzi2DPNvODEShGg7A" target="_blank">
                            <font-awesome-icon class="social-icon" :icon="['fab', 'square-youtube']" />
                        </a>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <h4>Contact Us</h4>
                    <div class="contact-container">            
                        <div>
                            <a href="mailto:info@hearos.com">
                                <font-awesome-icon :icon="['fas', 'envelope']" />
                            </a>                 
                            <a href="mailto:info@hearos.com">info@hearos.com</a>
                        </div>
                        <div>
                            <a href="tel:844-432-7327">
                                <font-awesome-icon :icon="['fas', 'phone']" />
                            </a>
                            <a href="tel:844-432-7327">(844) 432-7327</a>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <h4>Buy Now</h4>
                    <div>
                        <a href="https://www.amazon.com/stores/HEAROSEARPLUGS/page/2368092F-5117-40DD-9561-0158E3A79342?ref_=ast_bln" target="_blank" aria-label='Link opens in new window (amazon.com/stores/HearosEarPlugs)'>
                            <img id="amazon-logo" src="/images/amazon-logo-white.svg" alt="amazon logo">
                        </a>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    data() {
        return {};
    },
    methods: {
    }
};
</script>
